<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 151.9 32"
    :width="width">
    <title>PIXELSQUAD</title>
    <g
      id="Layer_2"
      data-name="Layer 2">
      <g
        id="Layer_1-2"
        data-name="Layer 1">
        <g
          id="Layer_2-2"
          data-name="Layer 2">
          <g
            id="Layer_1-2-2"
            data-name="Layer 1-2">
            <circle
              id="Ellipse_1"
              data-name="Ellipse 1"
              cx="16"
              cy="16"
              r="16" />
            <g
              id="Group_2"
              data-name="Group 2">
              <line
                id="Line_4"
                data-name="Line 4"
                x1="8.8"
                y1="22.21"
                x2="8.8"
                y2="22.21"
                style="fill:none;stroke:#000;stroke-width:5px" />
              <path
                id="Path_1"
                data-name="Path 1"
                d="M26.77,17.63c-.19-2.63-.48-3-.63-3.11L24.63,13.2c0-.68-.33-4.27-2.15-6.08C20.29,4.93,16,5,15.8,5S11.31,5,9.12,7.17C7.3,8.93,7,12.52,7,13.2L5.46,14.52c-.15.09-.44.49-.63,3.11h0l.22,3.05a1.69,1.69,0,0,0,.49,1.12l.9.88V23h0a1.57,1.57,0,0,0,.45.71l.06.05H8v-1.3h.74V22H7.94V16.94a2.36,2.36,0,0,1,.69-.75h0a2.87,2.87,0,0,1,.75-.54,30.11,30.11,0,0,0,6.36.41h.13a30,30,0,0,0,6.35-.41,2.92,2.92,0,0,1,.76.54h0a2.26,2.26,0,0,1,.69.75V22h-.8v.49h.8v1.3h.95l.07-.05a1.76,1.76,0,0,0,.45-.72h0v-.26l.9-.87a1.69,1.69,0,0,0,.49-1.12l.22-3.05Zm-.7,3h0a1.22,1.22,0,0,1-.35.78l-1,1v.38a1.25,1.25,0,0,1-.22.41h-.3V16.76h0a2.38,2.38,0,0,0-.86-1c-.22-.21-.75-.68-1.1-.68h-.06a29.19,29.19,0,0,1-6.33.42h0a29.19,29.19,0,0,1-6.33-.42H9.39c-.34,0-.88.47-1.1.68a2.38,2.38,0,0,0-.86,1h0V23.2h-.3a1.25,1.25,0,0,1-.22-.41v-.38l-1-1a1.26,1.26,0,0,1-.34-.78l-.22-3a8.23,8.23,0,0,1,.44-2.74l1.53-1.34.73.09-.55-.51c.06-.79.39-4.08,2-5.69,2.06-2.06,6.29-2,6.33-2h0c.05,0,4.28,0,6.34,2,1.61,1.62,1.94,4.92,2,5.7l-.54.5.72-.09,1.53,1.34a8,8,0,0,1,.43,2.74Z"
                style="fill:#fff" />
              <path
                id="Path_2"
                data-name="Path 2"
                d="M9.63,14.29a41.43,41.43,0,0,0,12.38,0Z"
                style="fill:#fff" />
              <path
                id="Path_3"
                data-name="Path 3"
                d="M22.25,15.37,17,16l-1.17,1.3-1.22-1.37A23.36,23.36,0,0,1,9.4,15.5a3.21,3.21,0,0,0-1,.75v9.19h2.29v-3H14l1.85-2.12,1.89,2.11H21V27l2.31-1.63v-9Zm-9,4.88H10.81v-2.8H13.3l1.29,1.39Zm7.75,0H18.5l-1.31-1.41,1.26-1.39H21Z"
                style="fill:#fff" />
            </g>
            <path
              id="Path_4"
              data-name="Path 4"
              d="M39.52,9.66V23h2.6V18.06H43.8a4.57,4.57,0,0,0,3.38-1.18,4.31,4.31,0,0,0,1.1-3,4.26,4.26,0,0,0-1.36-3.22,4.8,4.8,0,0,0-3.52-1Zm2.6,2.24H43a3.13,3.13,0,0,1,1.84.42,1.85,1.85,0,0,1,.74,1.52,2,2,0,0,1-.72,1.56,2.61,2.61,0,0,1-1.7.42h-1ZM50.2,9.66V23h2.6V9.66ZM54.48,23H57.6l3.08-4.88L63.6,23h3.12l-4.56-7,4.1-6.3H63.14l-2.46,4.1L58.34,9.66H55.22l4,6.3ZM76,9.66H68.6V23H76V20.76H71.2V17.12h4.6V14.88H71.2v-3H76Zm2.52,0V23h6.72V20.76H81.16V9.66ZM95,10.92a5.13,5.13,0,0,0-3.78-1.56c-3,0-4.28,2-4.28,3.92A3.13,3.13,0,0,0,88,15.76a6.47,6.47,0,0,0,2.22,1.16,6.07,6.07,0,0,1,2.06,1,1.55,1.55,0,0,1,.52,1.2A1.87,1.87,0,0,1,90.94,21h-.2a3.13,3.13,0,0,1-2.8-1.78l-1.7,1.62a5.49,5.49,0,0,0,4.6,2.52,4.31,4.31,0,0,0,4.63-3.93V19a3.6,3.6,0,0,0-1.14-2.8,7.77,7.77,0,0,0-2.7-1.34A4.6,4.6,0,0,1,90,14a1.12,1.12,0,0,1-.42-.9c0-.68.44-1.56,1.84-1.56a2.61,2.61,0,0,1,2.18,1.14Zm14.14,12.6,2.62-.26-2.16-2.18a6.74,6.74,0,0,0,1.76-4.74,6.78,6.78,0,0,0-6.55-7h-.57a6.76,6.76,0,0,0-7.11,6.39v0a5.42,5.42,0,0,0,0,.57,6.75,6.75,0,0,0,6.49,7h.63a7,7,0,0,0,3.8-1Zm-2.88-5.88-2.7.22,2.72,2.64a4.21,4.21,0,0,1-2,.44,4.34,4.34,0,0,1-4.5-4.17v0a2.67,2.67,0,0,1,0-.4,4.35,4.35,0,0,1,4.07-4.61h.37A4.36,4.36,0,0,1,108.69,16v.38a4.45,4.45,0,0,1-.88,2.88Zm7.5-8V17.8a5.57,5.57,0,0,0,1,3.56,5.91,5.91,0,0,0,8.35.37l.37-.37a5.57,5.57,0,0,0,1-3.56V9.66h-2.6V18a2.76,2.76,0,0,1-4.74,2.14L117,20a2.9,2.9,0,0,1-.64-2V9.66ZM136.54,23h2.8L133.76,9.66h-2L126,23h2.82L130,20.2h5.38Zm-5.74-4.92,1.9-4.8,1.9,4.8Zm10.1-8.42V23h3.44a7.61,7.61,0,0,0,4.88-1.28,6.36,6.36,0,0,0,2.68-5.38A6.6,6.6,0,0,0,149.34,11a7.77,7.77,0,0,0-5-1.3Zm2.6,2.24h.8a5.37,5.37,0,0,1,3.28.88,4.45,4.45,0,0,1,1.64,3.56,4.34,4.34,0,0,1-1.66,3.54,5.61,5.61,0,0,1-3.26.88h-.8Z" />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
	name: "PxsLogo",
	props: {
		width: {
			type: Number,
			default: 50,
			required: false
		}
	},
	data() {
		return {
			something: false,

		};
	}
};
</script>